import { createSelector } from "reselect";
import { mapValues } from "lodash";
import { RootState } from "../types";
import {
  DataSourcesById,
  DataSourcesReducerState,
  StateReducerProps,
} from "./types";
import {
  DataSourceModel,
  DataSourceState,
} from "../../requests/dataSources/types";

export const getDatasourcesSlice = (
  state: RootState
): DataSourcesReducerState => state.datasources;

export const getByIdDataSources = (state: RootState): DataSourcesById =>
  getDatasourcesSlice(state).byId;

export const getIsDataSourcesFetching = (state: RootState): boolean =>
  getDatasourcesSlice(state)?.isFetching ?? true;

export const getByIdDataSource = (
  state: RootState,
  dataSourceId: number | null
): DataSourceModel | undefined => {
  if (dataSourceId === null) return undefined;
  return getByIdDataSources(state)[dataSourceId]?.data;
};

export const getIsStateFetching = (state: RootState): boolean =>
  getDatasourcesSlice(state).isStateFetching;

export const getByIdDataSourceStateSlice = (
  state: RootState,
  dataSourceId: number
): StateReducerProps | undefined =>
  getByIdDataSources(state)[dataSourceId]?.state;

export const getDataSourceStateForId = (
  state: RootState,
  dataSourceId: number
): DataSourceState | undefined =>
  getByIdDataSourceStateSlice(state, dataSourceId)?.data;

export const getIsDataSourceStateFetchingForId = (
  state: RootState,
  dataSourceId: number
): boolean =>
  getByIdDataSourceStateSlice(state, dataSourceId)?.isFetching || false;

export const getDataSourcesDataById = createSelector(
  getByIdDataSources,
  (dataSourcesWithState) => mapValues(dataSourcesWithState, ({ data }) => data)
);
